import Vue from 'vue';

const state = {
  properties: {}
}

const getters = {

  property (state) {
    return id => {
      if (id in state.properties) return state.properties[id];
      else return false;
    }
  },

  properties (state) {
    return state.properties;
  }
}

const mutations = {

  storeProperties (state, properties) {
    
    properties.forEach(property => {
      var current = state.properties[property._id] || {};
      Vue.set(state.properties, property._id, {
        ...current,
        ...property
      });
    });
  },

  removeProperty (state, id) {
    if (id in state.properties) Vue.delete(state.properties, id);
  },

  clearProperties () {
    Vue.set(state, 'properties', {});
  }

}

const actions = {
  
  loadProperties ({commit}, params) {
    var filters = params.filters || {};

    if (!params.company) {
      return Promise.reject('state.property - loading Properties - Missing required param "company"');
    }

    var queryParams = {
      ...filters,
      populateAssignees: true
    };

    return window.server.getReq('company/' + params.company + '/properties', {
      params: queryParams
    })
    .then(data => {
      commit('storeProperties', data);
      return Promise.resolve(data);
    })  
    .catch(e => {
      return Promise.reject(e);
    });
  },
  
  loadProperty ({commit}, params) {
    var filters = params.filters || {};

    if (!params.property) {
      return Promise.reject('state.property - loading Property - Missing required param "property"');
    }

    var queryParams = {
      ...filters,
      populateAssignees: true
    };

    return window.server.getReq('property/' + params.property, {
      params: queryParams
    })
    .then(data => {
      var result = storeData([data]);
      commit('storeUsers', result.users)
      commit('storeProperties', result.properties);
      return Promise.resolve(result.properties[0]);
    })  
    .catch(e => {
      return Promise.reject(e);
    });
  },

  createProperty ({commit, dispatch}, params) {
    if (!params.property) {
      return Promise.reject('state.property - create Property - Missing required param "property"', params);
    }

    return window.server.postReq('company/' + params.company + '/property', {
      property: params.property
    })
    .then(data => {
      return dispatch('loadProperty', {property: data._id});
    })
    .catch(e => {
      return Promise.reject(e);
    });
  },

  deleteProperty ({commit}, params) {
    if (!params.property) {
      return Promise.reject('state.property - delete Property - Missing required param "property"');
    }

    return window.server.delReq('property/' + params.property)
    .then(data => {
      commit('removeProperty', params.property);
      return Promise.resolve(data);
    })
    .catch(e => {
      return Promise.reject(e);
    })
  },

  updateProperty ({commit, dispatch}, params) {
    if (!params.property) {
      return Promise.reject('state.property - update Property - Missing required param "property"', params);
    }

    return window.server.putReq('property/' + params.property._id, {
      property: params.property
    })
    .then(data => {
      return dispatch('loadProperty', {property: params.property._id});
    })
    .catch(e => {
      return Promise.reject(e);
    });
  },

  removePropertyAssignee ({commit, dispatch}, params) {
    if (!params.property) {
      return Promise.reject('state.property - remove Property Assignee - Missing required param "property"', params);
    }
    if (!params.status) {
      return Promise.reject('state.property - remove Property Assignee - Missing required param "status"', params);
    }
    if (!params.assignees) {
      return Promise.reject('state.property - remove Property Assignee - Missing required param "users"', params);
    }

    return window.server.putReq('property/' + params.property + '/' + params.status + '/remove/assignees', {
      assignees: params.assignees
    })
    .then(data => {
      return dispatch('loadProperty', {
        property: params.property
      });
    })
    .catch(e => {
      return Promise.reject(e);
    })
  },

  addPropertyAssignee ({commit, dispatch}, params) {
    if (!params.property) {
      return Promise.reject('state.property - remove Property Assignee - Missing required param "property"', params);
    }
    if (!params.status) {
      return Promise.reject('state.property - remove Property Assignee - Missing required param "status"', params);
    }
    if (!params.assignees) {
      return Promise.reject('state.property - remove Property Assignee - Missing required param "users"', params);
    }

    return window.server.putReq('property/' + params.property + '/' + params.status + '/add/assignees', {
      assignees: params.assignees
    })
    .then(data => {
      return dispatch('loadProperty', {
        property: params.property
      });
    })
    .catch(e => {
      return Promise.reject(e);
    })
  }
  
};

function storeData (properties) {
  
  var users = {};

  properties.forEach((property, i) => {

    for (var status in property.statuses) {    
    
      property.statuses[status].assignees.forEach((assignee, k) => {
        if (!(assignee._id in users)) users[assignee._id] = assignee;
        
        properties[i].statuses[status].assignees[k] = assignee._id;    
      });
    }
  });

  properties  = _.values(properties);
  users       = _.values(users);

  return {
    properties,
    users
  };
}

export default {
  state,
  getters,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/property.js